module.exports = __webpack_public_path__ + "static/media/level-page-background.ce66f5f0.png";